const el = '.kb-component--burger-menu'
const DOM = document.querySelector(el)

export default function(Store){
    if(DOM){
        const linkData = function(link){
            return {
                column: link.dataset.column,
                href: link.href,
                text: link.text,
                target: link.target,
                svgIcon: link.querySelector('.kb-icon') ? link.querySelector('.kb-icon').innerHTML : null
            }
        }
    
        const primaryLinksData = Array.from(DOM.querySelectorAll('[data-nav="primary"]')).map(linkData)
        const secondaryLinksData = Array.from(DOM.querySelectorAll('[data-nav="secondary"]')).map(linkData)
        
        const simpleCtaElement = DOM.querySelector('[data-nav="simple-cta"]')
        const simpleCtaData = simpleCtaElement ? {
            href: simpleCtaElement.href,
            text: simpleCtaElement.text
        } : null
        
        Store.commit('main/set_burger_menu_links',{
            primary: primaryLinksData,
            secondary: secondaryLinksData,
            simpleCta: simpleCtaData
        })
    }
}
